import axiosInst from "./config/axiosConfig";

/**
 * @param {*} softwareUpdateObject request containing a serial number and one or both firmware fields
 * @returns the pending-action API response, or null for an incomplete request
 */
async function updateEISoftwareHelper(softwareUpdateObject) {
  if (
    softwareUpdateObject.serialNumber === undefined ||
    softwareUpdateObject.serialNumber === null ||
    (!softwareUpdateObject.softwareVersion && !softwareUpdateObject.modemFirmware)
  ) {
    return null;
  }

  return axiosInst
    .post("/beta/pendingActionsUIHook", {
      ...softwareUpdateObject,
    })
    .then((response) => response);
}

export default updateEISoftwareHelper;
